import React from "react";
import Synonyms from "./Synonyms";

export default function Meaning({ meaning }) {
  return (
    <div>
      <h3>{meaning.partOfSpeech}</h3>
      <p>{meaning.definition}</p>
      <Synonyms synonyms={meaning.synonyms} />
    </div>
  );
}